import React, { useState, useEffect } from 'react';
import service from './services/service'
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { Button } from 'primereact/button';

export const HierarchicalQueryDb = (props) => {
    //Kullanılcak olan değişkenler ce methodlar tanımlanır
    const [countries, setCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [cities, setCitites] = useState([]);
    const [selectedCity, setSelectedCity] = useState(null);
    const [districts, setDistricts] = useState([]);
    const [selectedDistrict, setSelectedDistrict] = useState(null);
    const [neighbourhoods, setNeighbourhoods] = useState([]);
    const [selectedNeighbourhod, setSelectedNeighbourhod] = useState(null);
    const [roadLines, setRoadLines] = useState([]);
    const [selectedRoadLine, setSelectedRoadLine] = useState(null);
    const [doorNumbers, setDoorNumbers] = useState([]);
    const [selectedDoorNumber, setSelectedDoorNumber] = useState(null);
    const [mapTool, setMapTool] = useState(null);
    const [defaultStyle, setDefaultStyles] = useState({});

    const defaultCity = props.defaultSelectedCityName
        ? cities.find(city => city.name === props.defaultSelectedCityName)
        : null;

    let selectedLayerMain = "";
    useEffect(() => {

        window["hierarchicalToken"] = props.tokenKey;
        getDefaultItems();


    }, []);

    useEffect(() => {
        if (defaultCity) {
            setSelectedCity([defaultCity]);
            getDistricts([defaultCity.id]); // İlçeleri getir
        }
    }, [defaultCity, cities]);

    const getDefaultItems = () => {



        let sendData = { url: "", params: {}, element: '' };

        var defaultItems = [];

        if (props.items.find(x => x == "country" && props.defaultParameters["country"]) != null) {
            sendData.url = props.countryUrl;
            sendData.params = props.defaultParameters.country ? props.defaultParameters.country : {
                parentIds: [],
                Ids: [],
                Id: 0
            };
            sendData.element = "country";
            defaultItems.push({ ...sendData });
        }
        if (props.items.find(x => x == "city" && props.defaultParameters["city"]) != null) {
            sendData.url = props.cityUrl;
            sendData.params = props.defaultParameters?.city;
            sendData.element = "city";
            defaultItems.push({ ...sendData });
        }
        if (props.items.find(x => x == "district" && props.defaultParameters["district"]) != null) {
            sendData.url = props.districtUrl;
            sendData.params = props.defaultParameters?.district;
            sendData.element = "district";
            defaultItems.push({ ...sendData });
        }
        if (props.items.find(x => x == "neighbourhood") != null && props.defaultParameters["neighbourhood"]) {
            sendData.url = props.neighbourhoodUrl;
            sendData.params = props.defaultParameters?.neighbourhood;
            sendData.element = "neighbourhood";
            defaultItems.push({ ...sendData });
        }
        if (props.items.find(x => x == "roadLine") != null && props.defaultParameters["roadLine"]) {
            sendData.url = props.roadLineUrl;
            sendData.params = props.defaultParameters?.roadLine;
            sendData.element = "roadLine";
            defaultItems.push({ ...sendData });
        }
        if (props.items.find(x => x == "doorNumber") != null && props.defaultParameters["doorNumber"]) {
            sendData.url = props.doorNumberUrl;
            sendData.params = props.defaultParameters?.doorNumber;
            sendData.element = "doorNumber";
            defaultItems.push({ ...sendData });
        }
        if (props.mapTool) {
            setMapTool(props.mapTool);
            let mapTool = props.mapTool;
            //İl ilçe mahalle için ayrı ayrı layer eklenir
            let addedLayers = ["country", "city", "district", "neighbourhood", "roadLine", "doorNumber"];
            for (var i = 0; i < addedLayers.length; i++) {
                let layerName = props.layerName + addedLayers[i];
                if (mapTool.findLayer(layerName) == null) {

                    const layer = props.MapTool.createVectorLayer({
                        name: layerName,
                        source: props.MapTool.createVectorLayerSource({})
                    });
                    mapTool.addLayer(layer);
                }
                else {
                    console.log(layerName + " Layer mevcut")
                }
            }
            //Başlangıçta sitil atanmaz ise default sitil atar
            setDefaultStyles({
                countryStyle: props.countryStyle ? props.countryStyle : {
                    strokeWidth: 1,
                    strokeColor: '#f00',
                    fillColor: 'rgba(185, 251, 255, 0.5)',
                    label: "name",
                    isExtend: false
                },
                cityStyle: props.cityStyle ? props.cityStyle : {
                    strokeWidth: 1,
                    strokeColor: '#f00',
                    fillColor: 'rgba(185, 251, 255, 0.5)',
                    label: "name",
                    isExtend: false
                },
                districtStyle: props.districtStyle ? props.districtStyle : {
                    strokeWidth: 1,
                    strokeColor: '#f00',
                    fillColor: 'rgba(175, 255, 161, 0.5)',
                    label: "name",
                    isExtend: false
                },
                neighbourhoodStyle: props.neighbourhoodStyle ? props.neighbourhoodStyle : {
                    strokeWidth: 1,
                    strokeColor: '#f00',
                    fillColor: 'rgba(255, 236, 161, 0.5)',
                    label: "name",
                    isExtend: true
                },
                roadLineStyle: props.roadLineStyle ? props.roadLineStyle : {
                    strokeWidth: 1,
                    strokeColor: '#f00',
                    fillColor: 'rgba(255, 236, 161, 0.5)',
                    label: "name",
                    isExtend: true
                },
                doorNumberStyle: props.doorNumberStyle ? props.doorNumberStyle : {
                    strokeWidth: 1,
                    strokeColor: '#f00',
                    fillColor: 'rgba(255, 236, 161, 0.5)',
                    label: "name",
                    isExtend: true,
                    isCircle: true
                }
            });

        }
       

        for (let index = 0; index < defaultItems.length; index++) {
            const sendData = defaultItems[index];

            service.post(sendData.url, sendData.params).then(response => {
                if (!response) {
                    return;
                }
                if (!response.success) {
                    setCountries([]);

                }
                if (response && response.data && response.data.length) {
                    if (sendData.element === "country") {
                        setCountries(response.data);
                        if (response.data.length == 1) {
                            setSelectedCountry(response.data);
                            getCities(response.data.map(x => x.id));
                        }
                    }
                    if (sendData.element === "city") {

                        setCitites(setFirstIds(response.data, props.defaultParameters.city.firstIds));

                        if (response.data.length == 1) {
                            setSelectedCity(response.data);
                            if (props.items.includes("district")) {
                                getDistricts(response.data.map(x => x.id));
                            }
                        }
                        else if (props.defaultParameters.city.selectedId > 0) {
                            setSelectedCity(response.data.filter(x => x.id == props.defaultParameters.city.selectedId));
                            if (props.items.includes("district")) {
                                getDistricts([props.defaultParameters.city.selectedId]);
                            }
                        }

                    }
                    if (sendData.element === "district") {
                        setDistricts(setFirstIds(response.data, props.defaultParameters.district.firstIds));

                        if (response.data.length == 1) {
                            setSelectedDistrict(response.data);
                            if (props.items.includes("neighbourhood")) {
                                getNeighbourhoods(response.data.map(x => x.id));
                            }
                        }
                        else if (props.defaultParameters.district.selectedId > 0) {
                            setSelectedDistrict(response.data.filter(x => x.id == props.defaultParameters.district.selectedId));
                            if (props.items.includes("neighbourhood")) {
                                getNeighbourhoods([props.defaultParameters.district.selectedId]);
                            }
                        }

                    }
                    if (sendData.element === "neighbourhood") {

                        setNeighbourhoods(setFirstIds(response.data, props.defaultParameters.neighbourhood.firstIds));
                        if (response.data.length == 1) {
                            setSelectedNeighbourhod(response.data);
                            if (props.items.includes("roadLine")) {
                                getRoads(response.data.map(x => x.id));
                            }
                            //getNeighbourhoods(response.data.map(x => x.id));
                        }
                        else if (props.defaultParameters.neighbourhood.selectedId > 0) {
                            setSelectedNeighbourhod(response.data.filter(x => x.id == props.defaultParameters.neighbourhood.selectedId));
                            if (props.items.includes("roadLine")) {
                                getRoads([props.defaultParameters.neighbourhood.selectedId]);
                            }
                        }

                    }
                    if (sendData.element === "roadLine") {

                        setRoadLines(setFirstIds(response.data, props.defaultParameters.roadLine.firstIds));
                        if (response.data.length == 1) {
                            setSelectedRoadLine(response.data);
                            if (props.items.includes("doorNumber")) {
                                getDoorNumbers(response.data.map(x => x.id));
                            }
                            //getNeighbourhoods(response.data.map(x => x.id));
                        }
                        else if (props.defaultParameters.roadLine.selectedId > 0) {
                            setSelectedRoadLine(response.data.filter(x => x.id == props.defaultParameters.roadLine.selectedId));
                            if (props.items.includes("doorNumber")) {
                                getDoorNumbers([props.defaultParameters.roadLine.selectedId]);
                            }
                        }
                    }
                    if (sendData.element === "doorNumber") {

                        setDoorNumbers(setFirstIds(response.data, props.defaultParameters.doorNumber.firstIds));
                        setSelectedDoorNumber(response.data.filter(x => x.id == props.defaultParameters.doorNumber.selectedId));
                    }

                }
            }).catch(e => {
                console.log(e);
            });

        }

    }
    //Geometriyi oluştur ve göster
    const showGeometry = (url, layerName, wkt, styleProp, data, isClick) => {


        if (data.filter(x => x.wkt).length > 0) {
            for (var i = 0; i < data.length; i++) {

                let datas = props.MapTool.convertToFeature(response.data[i].wkt, props.mapTool.wktProjection, props.mapTool.mapProjection);

                if (mapTool.getBackgroundStyle && styleProp) {
                    if (datas.getGeometry().getType() === 'Point') {


                        datas.setStyle(mapTool.setFeatureStyleIcon(styleProp, { name: "" }));
                    }
                    else {
                        datas.setStyle(mapTool.getBackgroundStyle(styleProp, data[i], { name: "" }));
                    }

                }
                datas.set(layerName, data);
                datas.set("layerName", layerName);

                mapTool.addFeature(layerName, datas);

            }
            setTimeout(() => {

                if (styleProp.isExtend) {
                    mapTool.viewLayerExtent(layerName);
                }

            }, 1000);



            return;
        }
        //Eğer kullanıcı wkt yi direk göndermişse ordan çek
        service.post(url, { Ids: data.map(x => x.id) }).then(response => {

            if (!response.success) {
                return;
            }
            let datas = null;
            for (var i = 0; i < response.data.length; i++) {
                //datas = props.MapTool.convertToFeature(response.data[i].wkt, "EPSG:4326", "EPSG:3857");
                datas = props.MapTool.convertToFeature(response.data[i].wkt, props.mapTool.wktProjection, props.mapTool.mapProjection);



                if (mapTool.getBackgroundStyle && styleProp) {
                    if (datas.getGeometry().getType() === 'Point') {


                        datas.setStyle(mapTool.setFeatureStyleIcon(styleProp, { name: "" }));
                    }
                    else {

                        datas.setStyle(mapTool.getBackgroundStyle(styleProp, data[i], { name: "" }));
                    }

                }

                datas.set(layerName, data[i]);
                datas.set("layerName", layerName);


                mapTool.addFeature(layerName, datas);
                if (styleProp.isOnlyExtend) {
                    mapTool.viewLayerExtent(layerName, datas);
                }

            }
            if (props.onSelected) {
                props.onSelected({ type: selectedLayerMain, data: response.data });
            }
            if (props.onSelectedButton && props.showMapButton === true) {

                let selectedLayer = "";

                if (selectedDoorNumber && selectedDoorNumber.length > 0) {
                    selectedLayer = "doorNumber";
                }
                else if (selectedRoadLine && selectedRoadLine.length > 0) {
                    selectedLayer = "roadLine";
                }
                else if (selectedNeighbourhod && selectedNeighbourhod.length > 0) {
                    selectedLayer = "neighbourhood";
                }
                else if (selectedDistrict && selectedDistrict.length > 0) {
                    selectedLayer = "district";
                }
                else if (selectedCity && selectedCity.length > 0) {
                    selectedLayer = "city";
                }
                props.onSelectedButton({ type: selectedLayer, data: response.data });
            }


            if (props.isOnlyExtend) {
                return mapTool.viewLayerExtent(layerName, datas);
            }
            if (styleProp.isExtend) {
                return mapTool.viewLayerExtent(layerName);
            }


        });

    }


    const getDataWithhWkt = (url, layerName, wkt, styleProp, data, type) => {

        url = url.replaceAll("GetAll", "GetGeometry");
        if (data && data.length < 1) {
            return props.onSelected({ type: type, data: null });
        }
        if (props.onRequestStart) {
            props.onRequestStart();
        }
        //Eğer kullanıcı wkt yi direk göndermişse ordan çek
        service.post(url, { parentIds: data.map(x => x.id) }).then(response => {

            if (!response.success) {
                return;
            }
            let datas = null;

            if (props.onSelected) {

                let selectedLayer = type;

                props.onSelected({ type: selectedLayer, data: response.data });
            }
        });

    }
    //hangi katmana ekleneceği feature oluşturacak wkt stil varsa polygon sitili ve featurea eklencek info parametresi
    const getMap = (url, layerName, wkt, style, data) => {
        let addedLayers = ["country", "city", "district", "neighbourhood", "roadLine", "doorNumber"];


        props.mapTool.clearLayersByName(addedLayers.map(x => props.layerName + x));
        return showGeometry(url, layerName, wkt, style, data);


    }
    const setFirstIds = (data, ids) => {
        const datas = ids
            .map(id => data.find(item => item.id === id))
            .filter(item => item !== undefined);

        let datasOther = data.filter(x => ids.indexOf(x.id) <= -1);
        let dataa = [...datas, ...datasOther];
        return dataa;
    }
    const showMapWithButton = () => {
        let addedLayers = ["country", "city", "district", "neighbourhood"];


        props.mapTool.clearLayersByName(addedLayers.map(x => props.layerName + x));
        if (selectedDoorNumber && selectedDoorNumber.length > 0)
            getMap(props.doorNumberGeometryUrl, props.layerName + "doorNumber", true, props.doorNumberStyle, selectedDoorNumber);
        else if (selectedRoadLine && selectedRoadLine.length > 0)
            getMap(props.roadLineGeometryUrl, props.layerName + "roadLine", true, props.roadLineStyle, selectedRoadLine);
        else if (selectedNeighbourhod && selectedNeighbourhod.length > 0)

            getMap(props.neighbourhoodGeometryUrl, props.layerName + "neighbourhood", true, props.neighbourhoodStyle, selectedNeighbourhod);
        else if (selectedDistrict && selectedDistrict.length > 0)
            getMap(props.districtGeometryUrl, props.layerName + "district", true, props.districtStyle, selectedDistrict);
        else if (selectedCity && selectedCity.length > 0)
            getMap(props.cityGeometryUrl, props.layerName + "city", true, props.cityStyle, selectedCity);
        else if (selectedCountry && selectedCountry.length > 0)
            getMap(props.countryGeometryUrl, props.layerName + "country", true, props.countryStyle, selectedCountry);
    }
    const getDistricts = (value) => {
        //İlçeleri illere göre getir
        service.post(props.districtUrl, { parentIds: value, IsCenterDistrictAbove: props.IsCenterDistrictAbove, IsCenterDistrictKey: props.IsCenterDistrictKey }).then(response => {
            if (!response.sucess) {

            }
            if (response.data.length) {
                if (props.defaultParameters.district && props.defaultParameters.district.firstIds && props.defaultParameters.district.firstIds.length > 0) {

                    setDistricts(setFirstIds(response.data, props.defaultParameters.district.firstIds));
                }
                else {
                    setDistricts(response.data);
                }

            }

        }).catch(e => { });
    }
    const getCities = (value) => {
        //İlçeleri illere göre getir
        service.post(props.cityUrl, { parentIds: value }).then(response => {
            if (!response.sucess) {

            }
            if (props.defaultParameters.city && props.defaultParameters.city.firstIds && props.defaultParameters.city.firstIds.length > 0) {

                setCitites(setFirstIds(response.data, props.defaultParameters.city.firstIds));
            }
            else {
                setCitites(response.data);
            }
        }).catch(e => { });
    }
    const getNeighbourhoods = (value) => {
        //Mahalleleri ilçelere göre getir
        service.post(props.neighbourhoodUrl, { parentIds: value }).then(response => {
            if (!response.sucess) {

            }
            if (response.data.length)
                setNeighbourhoods(response.data);
        }).catch(e => { });
    }
    const getRoads = (value) => {
        //Mahalleleri ilçelere göre getir
        service.post(props.roadLineUrl, { parentIds: value }).then(response => {
            if (!response.sucess) {

            }
            if (response.data.length)
                setRoadLines(response.data);
        }).catch(e => { });
    }
    const getDoorNumbers = (value) => {
        //Mahalleleri ilçelere göre getir
        service.post(props.doorNumberUrl, { parentIds: value }).then(response => {
            if (!response.sucess) {

            }
            if (response.data.length)
                setDoorNumbers(response.data);
        }).catch(e => { });
    }



    const reset = () => {

        const citiesTemp = cities;
        if (props.isMultiple) {
            setSelectedCity([]);
            setSelectedDistrict([]);
            setSelectedNeighbourhod([]);
        }
        else {
            setSelectedCity({ id: -1 });
        }

        setDistricts([]);
        setNeighbourhoods([]);
        let addedLayers = ["city", "district", "neighbourhood"];


        props.mapTool.clearLayersByName(addedLayers.map(x => props.layerName + x));


    }
    if (countries.length < 1 && cities.length < 1 && districts.length < 1 && neighbourhoods.length < 1 && doorNumbers.length < 1 && roadLines.length < 1) {
        return (
            <div id={props.id ? props.id : "bs-hierarchial-layer"}>
                <h3>Yükleniyor...</h3>
            </div>)
    }
    //multiple seçilmişse çoklu seçim sağlar

    return (
        <div id={props.id ? props.id : "bs-hierarchial-layer"}>
            {props.title && <h3 id={props.id + "-title"}>  {props.title}  </h3>}


            {(props.items.includes("country") && countries.length > 0 && props.countryIsMultiple) && <MultiSelect
                filterLocale="tr"
                emptyMessage={props.emptyMessage}
                disabled={props.defaultParameters?.country && countries.length == 1}
                resetFilterOnHide="true"
                //maxSelectedLabels={3}
                filter
                value={selectedCountry}
                onChange={(e) => {
                    selectedLayerMain = "country";

                    setSelectedCountry(e.value);
                    setSelectedCity(null);
                    setCitites([]);
                    setSelectedDistrict(null);
                    setSelectedNeighbourhod(null);
                    setDistricts([])
                    setNeighbourhoods([])
                    setDoorNumbers([]);
                    setSelectedDoorNumber(null);
                    setRoadLines([]);
                    setSelectedRoadLine(null)
                    getCities(e.value.map(x => x.id));
                    let layerName = props.layerName + "country";



                    if (props.showCountry && props.showCountry === true) {
                        let layerName = props.layerName + "country";
                        mapTool.clearLayersByName([layerName]);
                        getMap(props.countryGeometryUrl, layerName, e.value, defaultStyle.countryStyle, e.value);
                    }
                    else {
                        if (props.onSelected) {
                            props.onSelected({ type: "country", data: e.value });
                        }
                    }
                }} options={countries} optionLabel="name"
                placeholder={props.selectedCountryLabel ? props.selectedCountryLabel : "Selected country"} />}

            {((props.items.includes("country") && countries.length > 0 && !props.countryIsMultiple)) && <Dropdown filterLocale="tr" emptyMessage={props.emptyMessage} disabled={props.defaultParameters?.country && countries.length == 1} resetFilterOnHide="true" filter value={selectedCountry && selectedCountry.length && selectedCountry[0]} onChange={(e) => {
                selectedLayerMain = "country";
                setSelectedCountry([e.value]);
                setSelectedCity(null)
                setSelectedDistrict(null)
                setSelectedNeighbourhod(null);
                setDistricts([])
                setNeighbourhoods([])
                setDoorNumbers([]);
                setSelectedDoorNumber(null);
                setRoadLines([]);
                setSelectedRoadLine(null)
                getCities([e.value].map(x => x.id));
                let layerName = props.layerName + "country";

                if (props.showCity && props.showCity === true) {
                    // let layerName = props.layerName + "country";
                    // mapTool.clearLayersByName([layerName]);
                    getMap(props.countryGeometryUrl, layerName, [e.value], defaultStyle.countryStyle, [e.value]);
                    //showMapWithButton();
                }
                else {
                    if (props.onSelected) {
                        props.onSelected({ type: "country", data: [e.value] });
                    }
                }
            }} options={countries} optionLabel="name"
                placeholder={props.selectedCountryLabel ? props.selectedCountryLabel : "Selected country"} />}


            {props.cityIsMultiple && (props.items.includes("city")) &&
                <MultiSelect
                    filterLocale="tr"
                    emptyMessage={props.emptyMessage}
                    disabled={props.defaultParameters?.city && cities.length == 1}
                    resetFilterOnHide="true"
                    //maxSelectedLabels={3}
                    filter
                    value={selectedCity}
                    onChange={(e) => {
                        selectedLayerMain = "city";
                        setSelectedCity(e.value);
                        setSelectedDistrict(null);
                        setSelectedNeighbourhod(null);
                        setDistricts([])
                        setNeighbourhoods([])
                        setDoorNumbers([]);
                        setSelectedDoorNumber(null);
                        setRoadLines([]);
                        setSelectedRoadLine(null)
                        getDistricts(e.value.map(x => x.id));
                        let layerName = props.layerName + "city";

                        if (props.showCity && props.showCity === true) {
                            // let layerName = props.layerName + "city";
                            // mapTool.clearLayersByName([layerName]);
                            getMap(props.cityGeometryUrl, layerName, e.value, defaultStyle.cityStyle, e.value);

                            //showMapWithButton();
                        }
                        else {
                            if (props.onSelected) {
                                props.onSelected({ type: "city", data: e.value });
                            }
                        }
                    }} options={cities} optionLabel="name"
                    placeholder={props.selectedCityLabel ? props.selectedCityLabel : "Selected city"} />}

            {!props.cityIsMultiple && (props.items.includes("city")) &&
                // <Dropdown
                //     filterLocale="tr"
                //     emptyMessage={props.emptyMessage}
                //     disabled={props.defaultParameters?.city && cities.length == 1}
                //     resetFilterOnHide="true"
                //     filter
                //     value={selectedCity && selectedCity.length && selectedCity[0]}
                //     onChange={(e) => {
                //         selectedLayerMain = "city";
                //         console.log(e.value);
                //         setSelectedCity([e.value]);
                //         setSelectedDistrict(null);
                //         setSelectedNeighbourhod(null);
                //         setDistricts([])
                //         setNeighbourhoods([])
                //         setDoorNumbers([]);
                //         setSelectedDoorNumber(null);
                //         setRoadLines([]);
                //         setSelectedRoadLine(null)
                //         getDistricts([e.value].map(x => x.id));
                //         let layerName = props.layerName + "city";


                //         if (props.showCity && props.showCity === true) {

                //             getMap(props.cityGeometryUrl, layerName, [e.value], defaultStyle.cityStyle, [e.value]);
                //             //showMapWithButton();
                //         }
                //         else {
                //             if (props.onSelected) {
                //                 props.onSelected({ type: "city", data: [e.value] });
                //             }
                //         }
                //     }} options={cities} optionLabel="name"
                //     placeholder={props.selectedCityLabel ? props.selectedCityLabel : "Selected city"} />
                <Dropdown
                    filterLocale="tr"
                    emptyMessage={props.emptyMessage}
                    disabled={!!defaultCity} // Eğer defaultSelectedCityName varsa disabled yap
                    resetFilterOnHide={true}
                    filter
                    value={selectedCity && selectedCity.length ? selectedCity[0] : null}
                    onChange={(e) => {
                        selectedLayerMain = "city";                      
                        setSelectedCity([e.value]);
                        setSelectedDistrict(null);
                        setSelectedNeighbourhod(null);
                        setDistricts([]);
                        setNeighbourhoods([]);
                        setDoorNumbers([]);
                        setSelectedDoorNumber(null);
                        setRoadLines([]);
                        setSelectedRoadLine(null);
                        getDistricts([e.value].map(x => x.id));

                        let layerName = props.layerName + "city";

                        if (props.showCity && props.showCity === true) {
                            getMap(props.cityGeometryUrl, layerName, [e.value], defaultStyle.cityStyle, [e.value]);
                        } else {
                            if (props.onSelected) {
                                props.onSelected({ type: "city", data: [e.value] });
                            }
                        }
                    }}
                    options={cities}
                    optionLabel="name"
                    placeholder={props.selectedCityLabel ? props.selectedCityLabel : "Selected city"}
                />
            }


            {props.districtIsMultiple && props.items.includes("district") &&
                <MultiSelect
                    filterLocale="tr"
                    emptyMessage={props.emptyMessage}
                    resetFilterOnHide="true"
                    //maxSelectedLabels={3} 
                    filter
                    value={selectedDistrict}
                    onChange={(e) => {
                        setSelectedDistrict(e.value);
                        setNeighbourhoods([]);
                        setSelectedNeighbourhod(null);
                        getNeighbourhoods(e.value.map(x => x.id));
                        setDoorNumbers([]);
                        setSelectedDoorNumber(null);
                        setRoadLines([]);
                        setSelectedRoadLine(null);
                        selectedLayerMain = "district";
                        let layerName = props.layerName + "district";

                        if (props.showDistrict && props.showDistrict === true) {

                            mapTool.clearLayersByName([layerName]);
                            getMap(props.districtGeometryUrl, layerName, e.value, defaultStyle.districtStyle, e.value);

                            //showMapWithButton();
                        }
                        else {
                            if (props.onSelected) {
                                props.onSelected({ type: "district", data: e.value });
                            }
                        }
                    }} options={districts} optionLabel="name"
                    placeholder={props.selectedDistrictLabel ? props.selectedDistrictLabel : "Selected district"} />}

            {!props.districtIsMultiple && (props.items.includes("district")) &&
                <Dropdown
                    filterLocale="tr"
                    emptyMessage={props.emptyMessage}
                    resetFilterOnHide="true"
                    filter
                    //maxSelectedLabels={3}
                    value={selectedDistrict && selectedDistrict.length && selectedDistrict[0]}
                    onChange={(e) => {
                        selectedLayerMain = "district";
                        if (props.onSelected) {
                            //props.onSelected({ type: "district", data: [e.value] });
                        }

                        setSelectedDistrict([e.value]);
                        setNeighbourhoods([]);
                        setSelectedNeighbourhod(null);
                        getNeighbourhoods([e.value].map(x => x.id));
                        setDoorNumbers([]);
                        setSelectedDoorNumber(null);
                        setRoadLines([]);
                        setSelectedRoadLine(null)
                        let layerName = props.layerName + "district";


                        if (props.showDistrict && props.showDistrict === true) {
                            mapTool.clearLayersByName([layerName]);
                            getMap(props.districtGeometryUrl, layerName, [e.value], defaultStyle.districtStyle, [e.value]);

                            //showMapWithButton();
                        }

                        else {
                            if (props.onSelected) {
                                props.onSelected({ type: "district", data: [e.value] });
                            }
                        }
                    }} options={districts} optionLabel="name"
                    placeholder={props.selectedDistrictLabel ? props.selectedDistrictLabel : "Selected district"} />}


            {props.neighbourhoodIsMultiple && props.items.includes("neighbourhood") &&
                <MultiSelect
                    filterLocale="tr"
                    emptyMessage={props.emptyMessage}
                    resetFilterOnHide="true"
                    //maxSelectedLabels={3}
                    filter
                    value={selectedNeighbourhod && selectedNeighbourhod.length && selectedNeighbourhod}
                    onChange={(e) => {
                        setSelectedNeighbourhod(e.value)
                        getRoads(e.value.map(x => x.id));
                        setSelectedDoorNumber(null);
                        setSelectedRoadLine(null);
                        let layerName = props.layerName + "neighbourhood";
                        selectedLayerMain = "neighbourhood";


                        if (props.showNeigborHood && props.showNeigborHood === true) {
                            mapTool.clearLayersByName([layerName]);
                            getMap(props.neighbourhoodGeometryUrl, layerName, e.value, defaultStyle.neighbourhoodStyle, e.value);
                            //showMapWithButton();
                        }
                        else {
                            if (props.onSelected) {
                                props.onSelected({ type: "neighbourhood", data: e.value });
                            }
                        }
                    }} options={neighbourhoods} optionLabel="name"
                    placeholder={props.selectedNeighbourhoodLabel ? props.selectedNeighbourhoodLabel : "Selected neighbourhood"} />}


            {!props.neighbourhoodIsMultiple && (props.items.includes("neighbourhood")) &&
                <Dropdown
                    filterLocale="tr"
                    emptyMessage={props.emptyMessage}
                    resetFilterOnHide="true"
                    //maxSelectedLabels={3} 
                    filter
                    value={selectedNeighbourhod && selectedNeighbourhod.length && selectedNeighbourhod[0]}
                    onChange={(e) => {
                        setSelectedNeighbourhod([e.value])
                        getRoads([e.value].map(x => x.id));
                        setSelectedRoadLine(null);
                        setSelectedDoorNumber(null);
                        selectedLayerMain = "neighbourhood";
                        let layerName = props.layerName + "neighbourhood";

                        if (props.showNeigborHood && props.showNeigborHood === true) {

                            mapTool.clearLayersByName([layerName]);

                            //showMapWithButton();
                            getMap(props.neighbourhoodGeometryUrl, layerName, [e.value], defaultStyle.roadLineStyle, [e.value]);


                        }
                        else {
                            if (props.onSelected) {
                                props.onSelected({ type: "neighbourhood", data: [e.value] });
                            }
                        }
                    }} options={neighbourhoods} optionLabel="name"
                    placeholder={props.selectedNeighbourhoodLabel ? props.selectedNeighbourhoodLabel : "Selected neighbourhood"} />}




            {props.roadLineIsMultiple && props.items.includes("roadLine") &&
                <MultiSelect
                    filterLocale="tr"
                    emptyMessage={props.emptyMessage}
                    resetFilterOnHide="true"
                    //maxSelectedLabels={3} 
                    filter
                    value={selectedRoadLine && selectedRoadLine.length && selectedRoadLine}
                    onChange={(e) => {
                        setSelectedRoadLine(e.value);
                        getDoorNumbers(e.value.map(x => x.id));
                        selectedLayerMain = "roadLine";
                        let layerName = props.layerName + "roadLine";

                        if (props.showRoadLine && props.showRoadLine === true) {
                            // mapTool.clearLayersByName([layerName]);
                            getMap(props.roadLineGeometryUrl, layerName, e.value, defaultStyle.roadLineStyle, e.value);
                            //showMapWithButton();
                        }
                        else {
                            if (props.onSelected) {
                                props.onSelected({ type: "roadLine", data: e.value });
                            }
                        }
                    }} options={roadLines} optionLabel="name"
                    placeholder={props.selectedRoadLineLabel ? props.selectedRoadLineLabel : "Selected roadLines"} />}


            {!props.roadLineIsMultiple && (props.items.includes("roadLine")) &&
                <Dropdown
                    filterLocale="tr"
                    emptyMessage={props.emptyMessage}
                    resetFilterOnHide="true"
                    //maxSelectedLabels={3}
                    filter
                    value={selectedRoadLine && selectedRoadLine.length && selectedRoadLine[0]}
                    onChange={(e) => {
                        setSelectedRoadLine([e.value]);
                        getDoorNumbers([e.value].map(x => x.id));
                        setSelectedDoorNumber(null);
                        selectedLayerMain = "roadLine";
                        let layerName = props.layerName + "roadLine";
                        if (props.showRoadLine && props.showRoadLine === true) {
                            // mapTool.clearLayersByName([layerName]);
                            getMap(props.roadLineGeometryUrl, layerName, [e.value], defaultStyle.doorNumberStyle, [e.value]);
                            //showMapWithButton();
                        }
                        else {
                            if (props.onSelected) {
                                props.onSelected({ type: "roadLine", data: [e.value] });
                            }
                        }
                    }} options={roadLines} optionLabel="name"
                    placeholder={props.selectedRoadLineLabel ? props.selectedRoadLineLabel : "Selected roadLines"} />}


            {props.doorNumberIsMultiple && props.items.includes("doorNumber") &&
                <MultiSelect
                    filterLocale="tr"
                    emptyMessage={props.emptyMessage}
                    resetFilterOnHide="true"
                    //maxSelectedLabels={3} 
                    filter
                    value={selectedDoorNumber && selectedDoorNumber.length && selectedDoorNumber}
                    onChange={(e) => {
                        setSelectedDoorNumber(e.value);

                        let layerName = props.layerName + "doorNumber";
                        selectedLayerMain = "doorNumber";
                        if (props.showDoorNumber && props.showDoorNumber === true) {
                            // mapTool.clearLayersByName([layerName]);
                            getMap(props.doorNumberGeometryUrl, layerName, e.value, defaultStyle.doorNumberStyle, e.value);
                            //showMapWithButton();
                        }
                        else {
                            if (props.onSelected) {
                                props.onSelected({ type: "doorNumber", data: e.value });
                            }
                        }
                    }} options={doorNumbers} optionLabel="name"
                    placeholder={props.selectedDoorNumberLabel ? props.selectedDoorNumberLabel : "Selected doornumber"} />}


            {!props.doorNumberIsMultiple && (props.items.includes("doorNumber")) &&
                <Dropdown
                    filterLocale="tr"
                    emptyMessage={props.emptyMessage}
                    resetFilterOnHide="true"
                    //maxSelectedLabels={3}
                    filter
                    value={selectedDoorNumber && selectedDoorNumber.length && selectedDoorNumber[0]}
                    onChange={(e) => {
                        setSelectedDoorNumber([e.value])
                        let layerName = props.layerName + "doorNumber";

                        selectedLayerMain = "doorNumber";

                        if (props.showDoorNumber && props.showDoorNumber === true) {
                            // mapTool.clearLayersByName([layerName]);
                            getMap(props.doorNumberGeometryUrl, layerName, [e.value], defaultStyle.doorNumberStyle, [e.value]);
                            //showMapWithButton();
                        }
                        else {
                            if (props.onSelected) {
                                props.onSelected({ type: "doorNumber", data: [e.value] });
                            }
                        }

                    }} options={doorNumbers} optionLabel="name"
                    placeholder={props.selectedDoorNumberLabel ? props.selectedDoorNumberLabel : "Selected doornumber"} />}

            {/* <div className="button-group">

                {props.showMapButton && <Button onClick={showMapWithButton} label="Göster" severity="primary" />}
                {props.showClearButton && <Button onClick={reset} label="Temizle" severity="secondary" />}

            </div> */}
            <div className="card flex justify-content-center" style={{ flexDirection: "column" }}>

                {props.showMapButton && <Button className='mt-2 w-full' onClick={showMapWithButton} label="Göster" severity="primary" />}
                {props.showClearButton && <Button label="Temizle" link onClick={reset} />}
            </div>

        </div>


    )

}

export default HierarchicalQueryDb;
